<article *ngFor="let job of list; trackBy: trackByJob" class="item">
  <div class="item__left">
    <header>
      <a class="item__title" [routerLink]="['/', featuresRoutingEnum.Job, job._id]">
        <h4 class="item__title">
          {{ job.title }}
        </h4>
      </a>
    </header>

    <div class="item__details">
      <span class="detail">
        <svg-icon class="detail__icon" icon="exp-briefcase" width="1.25em"></svg-icon>
        <i18n-contract [model]="job.contract"></i18n-contract>
      </span>

      <span class="detail">
        <svg-icon class="detail__icon" icon="exp-location" width="1.25em"></svg-icon>
        {{ job.city.short }}
      </span>

      <job-status class="item__left--status" [date]="job.dateCreated"></job-status>
    </div>
  </div>

  <footer class="item__right">
    <job-status class="item__right--status" [date]="job.dateCreated"></job-status>

    <a
      class="action btn"
      [routerLink]="['/', featuresRoutingEnum.Job, job._id]"
      appEventTracker
      eventCategory="Home"
      eventAction="Click Apply"
    >
      <ng-container i18n>Postuler</ng-container>
      <svg-icon class="action__icon" icon="exp-chevron-down" height=".38em" width=".58em"></svg-icon>
    </a>
  </footer>
</article>
